import React, { useState, useEffect, useRef } from 'react';
import { spkStore, SPK_STATUS } from './spkStore';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { CABANG_LABELS } from './dummyData';
import { lookupJob, wipStatus } from '../../services/gapfamilyAPI';

// Cari nomor job + posisi WIP dari sistem produksi (gapfamily) berdasar kode/nama produk.
const JobLookup = ({ keyword, onPick }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [res, setRes] = useState(null);

  const run = async () => {
    setOpen(true);
    setLoading(true);
    setRes(await lookupJob(keyword));
    setLoading(false);
  };

  return (
    <div style={{ marginTop: 10 }}>
      <button onClick={run} style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '6px 12px', borderRadius: 6, border: '1px solid #c4b5fd', background: '#f5f3ff', color: '#6d28d9', fontWeight: 700, fontSize: 12, cursor: 'pointer' }}>
        <i className="pi pi-search" style={{ fontSize: 11 }} /> Cari Nomor Job Produksi
      </button>
      {open && (
        <div style={{ marginTop: 8 }}>
          {loading && <div style={{ fontSize: 12, color: '#64748b' }}><i className="pi pi-spin pi-spinner" /> Mencari di sistem produksi…</div>}
          {!loading && res && !res.found && (
            <div style={{ fontSize: 12, color: '#94a3b8', fontStyle: 'italic' }}>
              Belum ada job produksi untuk produk ini{res.error ? ' (sistem produksi tidak terjangkau)' : ''}.
            </div>
          )}
          {!loading && res?.found && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
              {res.jobs.map((j) => {
                const w = wipStatus(j.wip_isi);
                return (
                  <div key={j.no_job} onClick={() => onPick?.(j.no_job)} style={{ cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 10px', border: '1px solid #e2e8f0', borderRadius: 6, background: '#fff' }}>
                    <div>
                      <div style={{ fontSize: 13, fontWeight: 700, color: '#111827' }}>Job #{j.no_job} <span style={{ fontSize: 11, color: '#94a3b8', fontWeight: 500 }}>{j.kode_buku}</span></div>
                      <div style={{ fontSize: 11, color: '#64748b' }}>{j.nama_buku} · oplah {(j.oplah || 0).toLocaleString()} · {j.tanggal || '-'}</div>
                      {j.proses_saat_ini && (
                        <div style={{ fontSize: 11, color: '#7c3aed', fontWeight: 600, marginTop: 2 }}>
                          <i className="pi pi-cog" style={{ fontSize: 10 }} /> Proses: {j.proses_saat_ini.workcenter}
                          {j.proses_saat_ini.tanggal ? ` · ${j.proses_saat_ini.tanggal}` : ''}
                          {j.proses_saat_ini.output ? ` · ${j.proses_saat_ini.output.toLocaleString()} pcs` : ''}
                        </div>
                      )}
                      {j.pengiriman && (
                        <div style={{ fontSize: 11, color: j.pengiriman.status === 'DITERIMA' ? '#16a34a' : '#2563eb', fontWeight: 600, marginTop: 2 }}>
                          <i className="pi pi-send" style={{ fontSize: 10 }} /> {j.pengiriman.status === 'DITERIMA' ? 'Diterima' : 'Dikirim'} ke {j.pengiriman.penerima || '-'} · {(j.pengiriman.total_kirim || 0).toLocaleString()} ({j.pengiriman.jumlah_sj} SJ)
                        </div>
                      )}
                    </div>
                    <span style={{ fontSize: 11, fontWeight: 700, color: w.color, background: w.bg, padding: '3px 8px', borderRadius: 5, whiteSpace: 'nowrap' }}>{w.label}</span>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

// ── helpers
const fmt = (v) => v ? new Date(v).toLocaleString('id-ID', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '-';
const fmtDate = (v) => v ? new Date(v).toLocaleDateString('id-ID', { day: '2-digit', month: 'long', year: 'numeric' }) : '-';

const STATUS_ORDER = ['DRAFT', 'DICETAK', 'IN_PRODUCTION', 'SELESAI', 'DIKIRIM', 'DITERIMA'];

// ── Print Preview component (rendered offscreen and printed)
const PrintPreview = ({ spk }) => {
  if (!spk) return null;
  return (
    <div id="spk-print-area" style={{ fontFamily: 'Arial, sans-serif', padding: '40px', color: '#111', fontSize: 13 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', borderBottom: '2px solid #000', paddingBottom: 16, marginBottom: 16 }}>
        <div>
          <div style={{ fontSize: 20, fontWeight: 900 }}>SURAT PERINTAH KERJA (SPK)</div>
          <div style={{ fontSize: 13, color: '#555', marginTop: 4 }}>PT Gelora Aksara Pratama</div>
        </div>
        <div style={{ textAlign: 'right', fontSize: 12 }}>
          <div><strong>No. SPK:</strong> {spk.id}</div>
          <div><strong>Tanggal:</strong> {fmtDate(spk.createdAt)}</div>
          <div><strong>PIC:</strong> {spk.pic}</div>
        </div>
      </div>

      <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: 24 }}>
        <tbody>
          {[
            ['Kode Item', spk.kode],
            ['Nama Barang', spk.nama],
            ['Satuan', spk.satuan],
            ['Kategori', spk.kategori],
            ['Qty Produksi', `${spk.qtyProduksi.toLocaleString()} ${spk.satuan}`],
            ['Defisit Nasional', `${spk.defisitNasional.toLocaleString()} ${spk.satuan}`],
          ].map(([label, val]) => (
            <tr key={label}>
              <td style={{ padding: '6px 12px 6px 0', fontWeight: 700, width: '35%', borderBottom: '1px solid #e5e7eb' }}>{label}</td>
              <td style={{ padding: '6px 0', borderBottom: '1px solid #e5e7eb' }}>{val}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div style={{ marginBottom: 16 }}>
        <div style={{ fontWeight: 700, marginBottom: 8 }}>Detail Defisit per Cabang:</div>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
          <thead>
            <tr style={{ background: '#f1f5f9' }}>
              <th style={{ padding: '6px 10px', textAlign: 'left', border: '1px solid #d1d5db' }}>Cabang</th>
              <th style={{ padding: '6px 10px', textAlign: 'right', border: '1px solid #d1d5db' }}>Stok Akhir</th>
              <th style={{ padding: '6px 10px', textAlign: 'right', border: '1px solid #d1d5db' }}>SP Belum Kirim</th>
              <th style={{ padding: '6px 10px', textAlign: 'right', border: '1px solid #d1d5db' }}>Selisih (Stok-SP)</th>
            </tr>
          </thead>
          <tbody>
            {spk.defisitCabang.map(c => (
              <tr key={c.cabang}>
                <td style={{ padding: '6px 10px', border: '1px solid #d1d5db' }}>{CABANG_LABELS[c.cabang] || c.cabang}</td>
                <td style={{ padding: '6px 10px', textAlign: 'right', border: '1px solid #d1d5db' }}>{c.stok.toLocaleString()}</td>
                <td style={{ padding: '6px 10px', textAlign: 'right', border: '1px solid #d1d5db' }}>{c.sp.toLocaleString()}</td>
                <td style={{ padding: '6px 10px', textAlign: 'right', border: '1px solid #d1d5db', color: c.selisih < 0 ? '#dc2626' : '#16a34a', fontWeight: 700 }}>{c.selisih.toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 40 }}>
        {['Dibuat Oleh', 'Disetujui Oleh', 'Diterima Produksi'].map(role => (
          <div key={role} style={{ textAlign: 'center', width: '30%' }}>
            <div style={{ marginBottom: 50, fontSize: 12, color: '#555' }}>{role}:</div>
            <div style={{ borderTop: '1px solid #000', paddingTop: 4, fontSize: 12 }}>({role === 'Dibuat Oleh' ? spk.pic : '................................'})</div>
          </div>
        ))}
      </div>
    </div>
  );
};

// ── Timeline component
const Timeline = ({ items }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
    {items.map((item, i) => (
      <div key={i} style={{ display: 'flex', gap: 12, position: 'relative' }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <div style={{ width: 10, height: 10, borderRadius: '50%', background: '#3b82f6', border: '2px solid #bfdbfe', flexShrink: 0, marginTop: 4 }} />
          {i < items.length - 1 && <div style={{ width: 2, flex: 1, background: '#e2e8f0', minHeight: 24 }} />}
        </div>
        <div style={{ paddingBottom: 16 }}>
          <div style={{ fontSize: 13, fontWeight: 600, color: '#111827' }}>{item.action}</div>
          <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 2 }}>{fmt(item.time)} · {item.by}</div>
        </div>
      </div>
    ))}
  </div>
);

// ── Status badge
const StatusBadge = ({ status }) => {
  const s = SPK_STATUS[status] || SPK_STATUS.DRAFT;
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5, padding: '4px 10px', borderRadius: 6, background: s.bg, color: s.color, fontWeight: 700, fontSize: 12 }}>
      {s.label}
    </span>
  );
};

// ── SPK Card
const SpkCard = ({ spk, onRefresh }) => {
  const [expanded, setExpanded] = useState(false);
  const [jobInput, setJobInput] = useState(spk.jobNumber || '');
  const [catatanKirim, setCatatanKirim] = useState('');
  const [confirming, setConfirming] = useState(null); // 'print' | 'selesai' | 'dikirim' | 'diterima'
  const printRef = useRef();

  const handlePrint = async () => {
    await spkStore.print(spk.id);
    onRefresh();
    setConfirming(null);
    setTimeout(() => window.print(), 100);
  };

  const handleSetJob = async () => {
    if (!jobInput.trim()) return;
    await spkStore.setJobNumber(spk.id, jobInput.trim());
    onRefresh();
  };

  const nextAction = () => {
    if (spk.status === 'DRAFT') return { label: 'Cetak SPK', icon: 'pi-print', color: '#7c3aed', confirmKey: 'print' };
    if (spk.status === 'DICETAK') return null; // needs job number input
    if (spk.status === 'IN_PRODUCTION') return { label: 'Tandai Selesai', icon: 'pi-check-circle', color: '#059669', confirmKey: 'selesai' };
    if (spk.status === 'SELESAI') return { label: 'Tandai Dikirim', icon: 'pi-send', color: '#2563eb', confirmKey: 'dikirim' };
    if (spk.status === 'DIKIRIM') return { label: 'Konfirmasi Diterima', icon: 'pi-home', color: '#16a34a', confirmKey: 'diterima' };
    return null;
  };

  const action = nextAction();
  const s = SPK_STATUS[spk.status];

  return (
    <div style={{ background: '#fff', borderRadius: 12, border: `1px solid ${s.bg}`, boxShadow: '0 1px 4px rgba(0,0,0,.06)', overflow: 'hidden', borderLeft: `4px solid ${s.color}` }}>
      {/* Header */}
      <div style={{ padding: '14px 18px', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} onClick={() => setExpanded(!expanded)}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <span style={{ fontSize: 11, fontWeight: 700, color: '#94a3b8', fontFamily: 'monospace' }}>{spk.id}</span>
            <StatusBadge status={spk.status} />
            {spk.jobNumber && (
              <span style={{ fontSize: 12, fontWeight: 700, color: '#d97706', background: '#fef3c7', padding: '2px 8px', borderRadius: 5 }}>
                Job #{spk.jobNumber}
              </span>
            )}
          </div>
          <div style={{ fontSize: 15, fontWeight: 800, color: '#111827' }}>{spk.nama} <span style={{ fontSize: 12, color: '#64748b', fontWeight: 500 }}>({spk.kode})</span></div>
          <div style={{ fontSize: 12, color: '#64748b' }}>
            Qty: <strong style={{ color: '#111' }}>{spk.qtyProduksi.toLocaleString()} {spk.satuan}</strong>
            <span style={{ margin: '0 8px', color: '#e2e8f0' }}>|</span>
            Defisit: <strong style={{ color: '#dc2626' }}>{spk.defisitNasional.toLocaleString()}</strong>
            <span style={{ margin: '0 8px', color: '#e2e8f0' }}>|</span>
            PIC: <strong>{spk.pic}</strong>
            <span style={{ margin: '0 8px', color: '#e2e8f0' }}>|</span>
            {fmt(spk.createdAt)}
          </div>
        </div>
        <i className={`pi ${expanded ? 'pi-chevron-up' : 'pi-chevron-down'}`} style={{ color: '#94a3b8', fontSize: 16 }} />
      </div>

      {expanded && (
        <div style={{ padding: '0 18px 18px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
          {/* Left: Actions + detail */}
          <div>
            {/* Job Number input for DICETAK */}
            {spk.status === 'DICETAK' && (
              <div style={{ marginBottom: 16, padding: 14, background: '#fef3c7', borderRadius: 8, border: '1px solid #fde68a' }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: '#92400e', marginBottom: 8 }}>Input No. Job Produksi:</div>
                <div style={{ display: 'flex', gap: 8 }}>
                  <InputText
                    value={jobInput}
                    onChange={e => setJobInput(e.target.value)}
                    placeholder="Contoh: JOB-4523"
                    style={{ flex: 1, fontSize: 13, padding: '8px 12px' }}
                    onKeyDown={e => e.key === 'Enter' && handleSetJob()}
                  />
                  <Button
                    label="Simpan"
                    icon="pi pi-check"
                    size="small"
                    severity="warning"
                    disabled={!jobInput.trim()}
                    onClick={handleSetJob}
                  />
                </div>
                <JobLookup keyword={spk.kode || spk.nama} onPick={setJobInput} />
              </div>
            )}

            {/* Kirim catatan for SELESAI */}
            {spk.status === 'SELESAI' && confirming === 'dikirim' && (
              <div style={{ marginBottom: 12, padding: 14, background: '#eff6ff', borderRadius: 8, border: '1px solid #bfdbfe' }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: '#1e40af', marginBottom: 8 }}>Catatan Pengiriman (opsional):</div>
                <InputText
                  value={catatanKirim}
                  onChange={e => setCatatanKirim(e.target.value)}
                  placeholder="No. surat jalan, ekspedisi, dll"
                  style={{ width: '100%', fontSize: 13, padding: '8px 12px', marginBottom: 8 }}
                />
              </div>
            )}

            {/* Action buttons */}
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 16 }}>
              {action && confirming !== action.confirmKey && (
                <button
                  onClick={() => setConfirming(action.confirmKey)}
                  style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '8px 14px', borderRadius: 8, border: 'none', background: action.color, color: '#fff', fontWeight: 700, fontSize: 13, cursor: 'pointer' }}
                >
                  <i className={`pi ${action.icon}`} style={{ fontSize: 14 }} />
                  {action.label}
                </button>
              )}

              {confirming === 'print' && (
                <div style={{ display: 'flex', gap: 8, alignItems: 'center', padding: '8px 12px', background: '#f3e8ff', borderRadius: 8, border: '1px solid #d8b4fe' }}>
                  <span style={{ fontSize: 13, fontWeight: 600, color: '#6b21a8' }}>Konfirmasi cetak SPK?</span>
                  <button onClick={handlePrint} style={{ padding: '6px 12px', borderRadius: 6, border: 'none', background: '#7c3aed', color: '#fff', fontWeight: 700, cursor: 'pointer', fontSize: 12 }}>Ya, Cetak</button>
                  <button onClick={() => setConfirming(null)} style={{ padding: '6px 12px', borderRadius: 6, border: '1px solid #d8b4fe', background: '#fff', fontWeight: 700, cursor: 'pointer', fontSize: 12 }}>Batal</button>
                </div>
              )}

              {/* Cetak ulang — bisa dilakukan berulang kali (tidak sekali pakai) */}
              {spk.status !== 'DRAFT' && (
                <button onClick={handlePrint} style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '8px 12px', borderRadius: 8, border: '1px solid #d8b4fe', background: '#fff', color: '#6b21a8', fontWeight: 600, fontSize: 13, cursor: 'pointer' }}>
                  <i className="pi pi-print" style={{ fontSize: 13 }} /> Cetak Ulang{spk.printCount > 0 ? ` (${spk.printCount}×)` : ''}
                </button>
              )}

              {confirming === 'selesai' && (
                <div style={{ display: 'flex', gap: 8, alignItems: 'center', padding: '8px 12px', background: '#d1fae5', borderRadius: 8, border: '1px solid #6ee7b7' }}>
                  <span style={{ fontSize: 13, fontWeight: 600, color: '#065f46' }}>Tandai produksi selesai?</span>
                  <button onClick={async () => { await spkStore.setSelesai(spk.id); onRefresh(); setConfirming(null); }} style={{ padding: '6px 12px', borderRadius: 6, border: 'none', background: '#059669', color: '#fff', fontWeight: 700, cursor: 'pointer', fontSize: 12 }}>Konfirmasi</button>
                  <button onClick={() => setConfirming(null)} style={{ padding: '6px 12px', borderRadius: 6, border: '1px solid #6ee7b7', background: '#fff', fontWeight: 700, cursor: 'pointer', fontSize: 12 }}>Batal</button>
                </div>
              )}

              {confirming === 'dikirim' && (
                <div style={{ display: 'flex', gap: 8, alignItems: 'center', padding: '8px 12px', background: '#dbeafe', borderRadius: 8, border: '1px solid #93c5fd' }}>
                  <span style={{ fontSize: 13, fontWeight: 600, color: '#1e40af' }}>Konfirmasi sudah dikirim?</span>
                  <button onClick={async () => { await spkStore.setDikirim(spk.id, catatanKirim); onRefresh(); setConfirming(null); setCatatanKirim(''); }} style={{ padding: '6px 12px', borderRadius: 6, border: 'none', background: '#2563eb', color: '#fff', fontWeight: 700, cursor: 'pointer', fontSize: 12 }}>Konfirmasi</button>
                  <button onClick={() => setConfirming(null)} style={{ padding: '6px 12px', borderRadius: 6, border: '1px solid #93c5fd', background: '#fff', fontWeight: 700, cursor: 'pointer', fontSize: 12 }}>Batal</button>
                </div>
              )}

              {confirming === 'diterima' && (
                <div style={{ display: 'flex', gap: 8, alignItems: 'center', padding: '8px 12px', background: '#dcfce7', borderRadius: 8, border: '1px solid #86efac' }}>
                  <span style={{ fontSize: 13, fontWeight: 600, color: '#166534' }}>Konfirmasi cabang sudah terima?</span>
                  <button onClick={async () => { await spkStore.setDiterima(spk.id); onRefresh(); setConfirming(null); }} style={{ padding: '6px 12px', borderRadius: 6, border: 'none', background: '#16a34a', color: '#fff', fontWeight: 700, cursor: 'pointer', fontSize: 12 }}>Konfirmasi</button>
                  <button onClick={() => setConfirming(null)} style={{ padding: '6px 12px', borderRadius: 6, border: '1px solid #86efac', background: '#fff', fontWeight: 700, cursor: 'pointer', fontSize: 12 }}>Batal</button>
                </div>
              )}

              {spk.status === 'DRAFT' && (
                <button
                  onClick={async () => { if (window.confirm('Hapus SPK ini?')) { await spkStore.delete(spk.id); onRefresh(); } }}
                  style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '8px 12px', borderRadius: 8, border: '1px solid #fca5a5', background: '#fff', color: '#dc2626', fontWeight: 600, fontSize: 13, cursor: 'pointer' }}
                >
                  <i className="pi pi-trash" style={{ fontSize: 13 }} /> Hapus
                </button>
              )}
            </div>

            {/* Defisit per cabang */}
            <div style={{ background: '#f8fafc', borderRadius: 8, padding: '12px 14px', border: '1px solid #e2e8f0' }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: '#475569', marginBottom: 8 }}>Detail Defisit Cabang:</div>
              {spk.defisitCabang.map(c => (
                <div key={c.cabang} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, marginBottom: 4 }}>
                  <span style={{ color: '#64748b' }}>{CABANG_LABELS[c.cabang] || c.cabang}</span>
                  <span style={{ fontWeight: 700, color: c.selisih < 0 ? '#dc2626' : '#16a34a' }}>
                    {c.selisih < 0 ? `defisit ${Math.abs(c.selisih).toLocaleString()}` : `aman +${c.selisih.toLocaleString()}`}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Right: Timeline */}
          <div>
            <div style={{ fontSize: 12, fontWeight: 700, color: '#475569', marginBottom: 12 }}>TIMELINE:</div>
            <Timeline items={[...spk.timeline].reverse()} />
          </div>
        </div>
      )}

      {/* Hidden print area */}
      <div ref={printRef} style={{ display: 'none' }}>
        <PrintPreview spk={spk} />
      </div>
    </div>
  );
};

// ── Rekap Usulan Cetak (laporan konsolidasi untuk management, printable) ──────
const RekapPrint = ({ list }) => {
  const active = (list || []).filter((s) => s.status !== 'DITERIMA');
  // Union cabang (kolom), urut sesuai kemunculan.
  const cabangCols = [];
  active.forEach((s) => (s.defisitCabang || []).forEach((c) => { if (!cabangCols.includes(c.cabang)) cabangCols.push(c.cabang); }));
  const needOf = (s, cab) => {
    const c = (s.defisitCabang || []).find((x) => x.cabang === cab);
    if (!c) return 0;
    return c.selisih < 0 ? Math.abs(c.selisih) : 0;
  };
  const totalQty = active.reduce((a, s) => a + (s.qtyProduksi || 0), 0);
  const colTotal = (cab) => active.reduce((a, s) => a + needOf(s, cab), 0);
  const th = { padding: '7px 8px', fontSize: 11, fontWeight: 700, borderBottom: '2px solid #111', textAlign: 'right', whiteSpace: 'nowrap' };
  const td = { padding: '6px 8px', fontSize: 11, borderBottom: '1px solid #e5e7eb', textAlign: 'right' };

  return (
    <div id="rekap-print-area" style={{ fontFamily: 'Arial, sans-serif', padding: 32, color: '#111' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', borderBottom: '3px solid #111', paddingBottom: 12, marginBottom: 16 }}>
        <div>
          <div style={{ fontSize: 20, fontWeight: 900, letterSpacing: '-.5px' }}>REKAP USULAN CETAK</div>
          <div style={{ fontSize: 12, color: '#555', marginTop: 2 }}>PT Gelora Aksara Pratama · Produksi &amp; Logistik</div>
        </div>
        <div style={{ textAlign: 'right', fontSize: 12 }}>
          <div><strong>Tanggal cetak:</strong> {fmtDate(new Date())}</div>
          <div><strong>Jumlah item:</strong> {active.length} · <strong>Total qty:</strong> {totalQty.toLocaleString()}</div>
        </div>
      </div>

      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th style={{ ...th, textAlign: 'left' }}>Kode</th>
            <th style={{ ...th, textAlign: 'left' }}>Nama Barang</th>
            <th style={th}>Qty Produksi</th>
            {cabangCols.map((c) => <th key={c} style={th}>{c}</th>)}
          </tr>
        </thead>
        <tbody>
          {active.map((s, i) => (
            <tr key={s.id} style={{ background: i % 2 ? '#fafafa' : '#fff' }}>
              <td style={{ ...td, textAlign: 'left', fontFamily: 'monospace' }}>{s.kode}</td>
              <td style={{ ...td, textAlign: 'left', fontWeight: 600 }}>{s.nama}</td>
              <td style={{ ...td, fontWeight: 800 }}>{(s.qtyProduksi || 0).toLocaleString()} <span style={{ color: '#888', fontWeight: 400 }}>{s.satuan}</span></td>
              {cabangCols.map((c) => {
                const n = needOf(s, c);
                return <td key={c} style={{ ...td, color: n > 0 ? '#b91c1c' : '#cbd5e1', fontWeight: n > 0 ? 700 : 400 }}>{n > 0 ? n.toLocaleString() : '·'}</td>;
              })}
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr style={{ borderTop: '2px solid #111', fontWeight: 800 }}>
            <td colSpan={2} style={{ ...td, textAlign: 'left', fontSize: 12 }}>TOTAL KEBUTUHAN</td>
            <td style={{ ...td, fontSize: 12 }}>{totalQty.toLocaleString()}</td>
            {cabangCols.map((c) => <td key={c} style={{ ...td, fontSize: 12 }}>{colTotal(c).toLocaleString()}</td>)}
          </tr>
        </tfoot>
      </table>

      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 48, fontSize: 12 }}>
        {['Dibuat oleh', 'Diperiksa', 'Disetujui (GM Produksi)'].map((r) => (
          <div key={r} style={{ textAlign: 'center', width: 180 }}>
            <div style={{ borderBottom: '1px solid #111', height: 48, marginBottom: 6 }} />
            <div style={{ fontWeight: 600 }}>{r}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

// ── Main SpkBoard Component
const SpkBoard = () => {
  const [spkList, setSpkList] = useState([]);
  const [filterStatus, setFilterStatus] = useState('ALL');
  const [printSpk, setPrintSpk] = useState(null);
  const [showRekap, setShowRekap] = useState(false);

  const handleRekapPrint = () => {
    setShowRekap(true);
    setTimeout(() => { window.print(); setShowRekap(false); }, 150);
  };

  const refresh = async () => setSpkList(await spkStore.getAll());

  useEffect(() => {
    refresh();
  }, []);

  const filtered = filterStatus === 'ALL'
    ? spkList
    : spkList.filter(s => s.status === filterStatus);

  const counts = STATUS_ORDER.reduce((acc, k) => {
    acc[k] = spkList.filter(s => s.status === k).length;
    return acc;
  }, {});

  return (
    <div style={{ paddingTop: 12 }}>
      {/* Print area (outside viewport, shown only when printing) */}
      {printSpk && (
        <div className="print-only">
          <PrintPreview spk={printSpk} />
        </div>
      )}
      {showRekap && (
        <div className="print-only">
          <RekapPrint list={spkList} />
        </div>
      )}

      {/* Toolbar */}
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 12 }}>
        <button
          onClick={handleRekapPrint}
          disabled={spkList.filter(s => s.status !== 'DITERIMA').length === 0}
          style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '9px 16px', borderRadius: 10, border: 'none', background: '#111827', color: '#fff', fontWeight: 700, fontSize: 13, cursor: 'pointer', opacity: spkList.filter(s => s.status !== 'DITERIMA').length === 0 ? .5 : 1 }}
        >
          <i className="pi pi-print" style={{ fontSize: 14 }} /> Cetak Rekap Usulan (per cabang)
        </button>
      </div>

      {/* KPI strip */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
        {[
          { key: 'ALL', label: 'Semua', count: spkList.length, color: '#334155', bg: '#f1f5f9' },
          ...STATUS_ORDER.map(k => ({ key: k, ...SPK_STATUS[k], count: counts[k] || 0 }))
        ].map(s => (
          <button
            key={s.key}
            onClick={() => setFilterStatus(s.key)}
            style={{
              display: 'flex', alignItems: 'center', gap: 6, padding: '8px 14px', borderRadius: 10, border: `1px solid ${filterStatus === s.key ? s.color : '#e2e8f0'}`,
              background: filterStatus === s.key ? s.bg : '#fff', color: filterStatus === s.key ? s.color : '#64748b',
              fontWeight: 700, fontSize: 13, cursor: 'pointer', transition: 'all .15s'
            }}
          >
            {s.label}
            <span style={{ background: filterStatus === s.key ? s.color : '#e2e8f0', color: filterStatus === s.key ? '#fff' : '#64748b', borderRadius: 10, padding: '1px 7px', fontSize: 11, fontWeight: 800 }}>
              {s.count}
            </span>
          </button>
        ))}
      </div>

      {/* List */}
      {filtered.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '60px 20px', background: '#fff', borderRadius: 12, border: '1px dashed #e2e8f0' }}>
          <i className="pi pi-inbox" style={{ fontSize: 40, color: '#cbd5e1', display: 'block', marginBottom: 12 }} />
          <div style={{ fontSize: 15, fontWeight: 600, color: '#94a3b8' }}>Belum ada SPK</div>
          <div style={{ fontSize: 13, color: '#cbd5e1', marginTop: 4 }}>
            {filterStatus === 'ALL' ? 'Buat SPK dari tab Laporan Stok Harian untuk item yang defisit.' : `Tidak ada SPK dengan status "${SPK_STATUS[filterStatus]?.label}".`}
          </div>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {filtered.map(spk => (
            <SpkCard key={spk.id} spk={spk} onRefresh={refresh} />
          ))}
        </div>
      )}

      <style>{`
        @media print {
          body > * { display: none !important; }
          .print-only { display: block !important; }
          #spk-print-area { display: block !important; }
          #rekap-print-area { display: block !important; }
          @page { size: landscape; margin: 12mm; }
        }
        .print-only { display: none; }
      `}</style>
    </div>
  );
};

export default SpkBoard;
